import React, { useState } from 'react';

import css from './TnaModuleGeneralEdit.module.css';
import AddEditForm from '../../../_common/elements/forms/AddEditForm';
import FormData from '../../../_common/elements/forms/FormData';
import FormComment from '../../../_common/elements/forms/FormComent';
import FormButtons from '../../../_common/elements/forms/FormButtons';

import toShort from '../../../../../services/utils/dateParser';

import * as tnaServices from '../../../../../services/tnaServices';

function TnaModuleGeneralEdit({ tnaModuleData, onAdd, toggleModal, method = 'edit' }) {
    const template = {
        tnaModuleId: tnaModuleData?.tnaModuleId || '',
        tnaModuleNo: tnaModuleData?.tnaModuleNo || '',
        tnaModuleType: tnaModuleData?.tnaModuleType || '',
        tnaModuleRevNo: tnaModuleData?.tnaModuleRevNo || '',
        tnaModuleRevDate: tnaModuleData.tnaModuleRevDate || '',
        tnaModuleNote: tnaModuleData?.tnaModuleNote || '',
        tnaModuleTitle: tnaModuleData?.tnaModuleTitle || '',
    };

    const [message, setMessage] = useState({ message: '', color: 'black' }); //check why colors are not changing

    const [data, setData] = useState(tnaModuleData || template);
    const [newData, setNewData] = useState(template);

   
    
    const handleChange = (e) => {
        const { id, value } = e.target;

        setNewData((state) => ({
            ...state,
            [id]: value,
        }));
    };

    const onAddStay = (e) => {
        handleSubmit(e);
        setNewData((state) => template);
    };

    const onAddClose = (e) => {
        let pass = handleSubmit(e);
        if (pass) {
            toggleModal();
        }
    };

    // ###############################################
    // check before using
    const handleSubmit = async (e) => {
        e.preventDefault();
        tnaServices
            .create(newData)
            .then((result) => {
                console.log(result);
                setNewData((prevDate) => template);
                setMessage((state) => ({ message: result.message, color: 'green' })); //check why colors are not changing
                onAdd(newData);
                return true;
            })
            .catch((err) => {
                // console.log(err);
                setMessage((state) => ({ message: 'Sorry, something went wrong!', color: 'red' })); //check why colors are not changing
                console.log(message); //check why colors are not changing
                return false;
            });
    };
    // ###############################################

    const onEdit = (e) => {
        e.preventDefault();
        const updateData = newData;
        updateData._id = data.tnaModuleId;

        tnaServices
            .updateModuleGeneral(updateData)
            .then((res) => {
                setMessage({
                    message: `${updateData.tnaModuleNo} is updated successfully!`,
                    color: 'green',
                });
                toggleModal();
            })
            .catch((err) => {
                setMessage({ message: err.message || 'Unknown error ...', color: 'red' });
            });
    };

    return (
        <AddEditForm>
            <FormData>
            {/* <p>{data.tnaModuleId}</p> */}

                <label className={css.label} htmlFor="tnaModuleTitle">
                    Title:{' '}
                </label>
                <input className={css.input} type="text" id="tnaModuleTitle" value={newData.tnaModuleTitle} onChange={handleChange} />
                <label className={css.label} htmlFor="tnaModuleNo">
                    Ref.:{' '}
                </label>
                <input className={css.input} type="text" id="tnaModuleNo" value={newData.tnaModuleNo} onChange={handleChange} />

                <label className={css.label} htmlFor="tnaModuleType">
                    Type:{' '}
                </label>
                <input className={css.input} type="text" id="tnaModuleType" value={newData.tnaModuleType} onChange={handleChange} />

                <label className={css.label} htmlFor="tnaModuleRevNo">
                    Rev:{' '}
                </label>
                <input className={css.input} type="number" id="tnaModuleRevNo" value={newData.tnaModuleRevNo} onChange={handleChange} />

                <label className={css.label} htmlFor="tnaModuleRevDate">
                    Rev date:{' '}
                </label>
                <input className={css.input} type="text" id="tnaModuleRevDate" value={newData.tnaModuleRevDate} onChange={handleChange} />
            </FormData>
            <FormComment>
                <label htmlFor="tnaModuleNote">Notes</label>
                <textarea id="tnaModuleNote" className={css.textarea} rows="32" onChange={handleChange} value={newData.tnaModuleNote}>
                    {/* {newData.tnaModuleNote} */}
                </textarea>
            </FormComment>
            <FormButtons>
                {method === 'add' && (
                    <div className={css.submitButtons}>
                        <button className={css.greenButton} onClick={onAddStay}>
                            Add Module and stay
                        </button>
                        <button className={css.greenButton} onClick={onAddClose}>
                            Add Module and close
                        </button>
                    </div>
                )}
                {method === 'edit' && (
                    <div className={css.submitButtons}>
                        <button className={css.orangeButton} onClick={onEdit}>
                            Edit Module
                        </button>
                    </div>
                )}
                <button onClick={toggleModal} className={`${css.redButton} ${css.buttonClose}`}>
                    Cancel
                </button>
            </FormButtons>
            <p className={css[message.color]}>{message.message}</p>
        </AddEditForm>
    );
}
export default TnaModuleGeneralEdit;
